import type { ConversationProjectionItem } from '../types';

type Props = {
  items: ConversationProjectionItem[];
  loading: boolean;
};

function itemLabel(item: ConversationProjectionItem) {
  if (item.kind === 'mcp_activity') return item.title || 'Tool activity';
  if (item.kind === 'structured_json_execution') return item.title || 'Agent run';
  if (item.kind === 'session_lifecycle') return item.title || 'Agent session';
  if (item.kind === 'normalized_message') {
    return item.title || (item.role === 'assistant' ? 'Agent response' : 'Agent activity');
  }
  return item.title || 'Agent checkpoint';
}

function isVisibleItem(item: ConversationProjectionItem) {
  return [
    'mcp_activity',
    'structured_json_execution',
    'session_lifecycle',
    'normalized_message'
  ].includes(item.kind);
}

export function InteractiveAgentFeed({ items, loading }: Props) {
  const visible = items.filter(isVisibleItem);
  if (!visible.length && !loading) return null;

  return (
    <div className="interactive-agent-feed" aria-label="Interactive agent activity">
      {visible.map((item) => (
        <article key={item.id} className="interactive-agent-feed__item">
          <div className="message-meta">
            <strong>{itemLabel(item)}</strong>
            {item.status && <span className="badge">{item.status}</span>}
            <time dateTime={item.timestamp}>{new Date(item.timestamp).toLocaleString()}</time>
          </div>
          {item.content && <p>{item.content}</p>}
        </article>
      ))}
      {loading && <span className="hint">Updating activity...</span>}
    </div>
  );
}
